import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import 'mdui/components/button-icon.js';

const MDUIIconButton = React.forwardRef(
  (
    {
      onClick,
      icon,
      variant = 'standard',
      size = 'medium',
      style,
      loading,
      children,
      color,
      borderColor,
      ...props
    },
    ref
  ) => {
    const buttonRef = useRef(null);
    let iconSize;
    let loadingIconSize;
    switch (size) {
      case 'small':
        iconSize = { 'font-size': '16px', width: '24px', height: '24px' };
        loadingIconSize = { width: '16px' };
        break;
      case 'medium':
        iconSize = { 'font-size': '20px', width: '20px', height: '20px' };
        loadingIconSize = { width: '16px' };
        break;
      case 'large':
        iconSize = { 'font-size': '32px' };
        loadingIconSize = { width: '32px' };
        break;
      default:
        break;
    }
    return loading ? (
      <mdui-circular-progress
        className={`mdui-button-icon mdui-button-icon-${variant}`}
        style={{ ...style, ...loadingIconSize }}
      />
    ) : (
      <mdui-button-icon
        ref={el => {
          buttonRef.current = el;
          if (typeof ref === 'function') ref(el);
          else if (ref) {
            const refCurrent = ref;
            refCurrent.current = el;
          }
        }}
        className={`mdui-button-icon mdui-button-icon-${variant}`}
        style={{
          ...iconSize,
          ...{
            color: color || 'rgb(var(--mdui-color-primary)',
            borderColor: borderColor || 'rgb(var(--mdui-color-primary))'
          },
          ...style
        }}
        onClick={event => {
          event.stopPropagation(); // Prevents double execution
          if (onClick) {
            onClick(event);
          }
        }}
        icon={icon}
        variant={variant}
        {...props}
      >
        {children}
      </mdui-button-icon>
    );
  }
);

MDUIIconButton.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  variant: PropTypes.oneOf(['standard', 'filled', 'tonal', 'outlined']),
  style: PropTypes.object,
  loading: PropTypes.bool,
  children: PropTypes.node,
  color: PropTypes.string,
  borderColor: PropTypes.string
};

export default MDUIIconButton;
